import _get from 'lodash/get'
import API from '../../shared/constants'
import {
  _getAggregateRating,
  _getContentRating,
  _getCountryOfOrigin,
  _getCoverUrl,
  _getFipRouteName,
  _getFipRouteParams,
  _getPartOfSeries,
  _getPersons,
  _getProductionCompany,
  _getReleaseDate
} from '../../shared/utils'

/**
 * Get season rich data
 * @param item
 * @param router
 * @param baseUrl
 * @returns {{image: *, '@type': string, author: {'@type': string, name: string}[], description, inLanguage: {'@type': string, name: string}[], subtitleLanguage: {'@type': string, name: string}[], '@context': string, url: *, duration: string, actor: {'@type': string, name: string}[], name, genre, contentRating: string}}
 */
function getSeason (item, router, baseUrl) {
  const url = baseUrl + router.resolve({ name: _getFipRouteName(item.type, item.videoType), params: _getFipRouteParams(item) }).href
  const image = _getCoverUrl(item, API.IMAGE_TYPE.COVER)
  const name = _get(item, 'title', null)

  return {
    '@context': 'http://schema.org',
    '@type': 'TVSeason',
    url,
    name,
    image,
    genre: _get(item, 'genres', []),
    description: _get(item, 'synopsis', ''),
    seasonNumber: _get(item, 'seriesInfo.seasonNumber', 1),
    contentRating: _getContentRating(item),
    ..._getAggregateRating(item),
    ..._getCountryOfOrigin(item),
    ..._getPersons(item),
    ..._getReleaseDate(item),
    ..._getProductionCompany(item),
    ..._getPartOfSeries(item)
  }
}

export {
  getSeason
}
